import loadable from "@loadable/component";
import Tasks from "pages/Tasks";
import Billing from "pages/billing";
import Billingclientoverview from "pages/billing/clients/billingclientoverview";
import Billingclientview from "pages/billing/clients/billingclientview";
import Invoices from "pages/billing/invoices";
import InvoicePreview from "pages/billing/invoices/invoice-preview";
import Receipts from "pages/billing/receipts";
import ReceiptPreview from "pages/billing/receipts/receipt-preview";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import IncomeTaxReturns from "pages/atom-pro/income-tax-returns";
import IncomeTaxForms from "pages/atom-pro/income-tax-forms";
import IncomeTaxEProceedings from "pages/atom-pro/income-tax-eproceedings";
import IncomeTaxOrder from "pages/atom-pro/income-tax-order";
import FormFullView from "views/atom-pro/formFullView";
import ClientFullView from "views/atom-pro/clientFullView";
import ClientIncomeTaxView from "views/atom-pro/ClientIncomeTaxView";
import ClientForm from "views/atom-pro/clientForm";
import ReturnFullView from "views/atom-pro/ReturnFullView";
import ClientIncometaxReturns from "views/atom-pro/clientReturns";
import OutstandingDemandView from "views/atom-pro/OutstandingDemandView";
import ClientDemand from "views/atom-pro/clientDemand";
import EproceedingView from "views/atom-pro/EproceedingView";
import FYANoticeView from "views/atom-pro/FYANoticeView";
import FYINoticeView from "views/atom-pro/FYINoticeView";
import EproceedingFyiView from "views/atom-pro/EproceedingFyiView";
import ClientProceeding from "views/atom-pro/clientProceeding";
import ClientIncomeTaxActivityLog from "views/atom-pro/clientActivityLog";
import ClientAutoStatus from "views/atom-pro/clientAutoStatus";
import IncomeTaxReports from "pages/atom-pro/reports";
import NewUpdates from "pages/atom-pro/new-updates";
import UpdatesFullVIew from "views/atom-pro/NewUpdates/ItemFullView"
import GstrCompliance from "views/atom-pro/Gstr/modules/gstrCompliance";
import PageWithPermission from "components/PageWithPermission";
import { Permissions } from "data/permissons";
import Proforma from "pages/billing/proforma";
import Tan from "pages/atom-pro/Tan";
import TanDashboard from "pages/atom-pro/Tan/dashboard";
import TanIncomeTaxChallans from "pages/atom-pro/Tan/income-tax-challans";
import TanIncomeTaxDemands from "pages/atom-pro/Tan/income-tax-demands";
import TanIncomeTaxForms from "pages/atom-pro/Tan/income-tax-forms";
import TanIncomeTaxMycas from "pages/atom-pro/Tan/income-tax-mycas";
import TanNewUpdates from "pages/atom-pro/Tan/new-updates";
import TanIncomeTaxReports from "pages/atom-pro/Tan/reports";
import TanExcelNotices from "pages/atom-pro/Tan/tan-excel-notices";
import TempTanNoticesFilterPage from "pages/atom-pro/Tan/tempNotices";
import TraceCommunication from "pages/atom-pro/Tan/trace-communication";
import AtomProTanCalendar from "views/atom-pro/Tan/Dashboard/Calendar";
import TanUpdatesFullVIew from "views/atom-pro/Tan/NewUpdates/ItemFullView";
import TanClientIncomeTaxView from "views/atom-pro/Tan/clientInsideView/ClientIncomeTaxView";
import TanClientIncomeTaxActivityLog from "views/atom-pro/Tan/clientInsideView/clientActivityLog";
import TanClientAutoStatus from "views/atom-pro/Tan/clientInsideView/clientAutoStatus";
import TanClientFullView from "views/atom-pro/Tan/clientInsideView/clientFullView";
import TraceDemandFullView from "views/atom-pro/Tan/clientInsideView/demandFullView";
import TanEChallanFullView from "views/atom-pro/Tan/clientInsideView/eChallanFullView";
import TanFormFullView from "views/atom-pro/Tan/clientInsideView/formFullView";
import TanClientChallan from "views/atom-pro/Tan/clientView/clientChallan";
import TanTraceCommunication from "views/atom-pro/Tan/clientView/clientCommunication";
import TraceClientDemand from "views/atom-pro/Tan/clientView/clientDemand";
import TanClientForm from "views/atom-pro/Tan/clientView/clientForm";
import TanClientMycas from "views/atom-pro/Tan/clientView/clientMycas";
import TanClientTempNotice from "views/atom-pro/Tan/clientView/clientTempNotice";
import TanTraceInvalidate from "views/atom-pro/Tan/invalidate";
import TanTdsFormAnalytics from "views/atom-pro/Tan/tdsFormAnalytics";
import ClientLedgers from "views/atom-pro/Gstr/modules/clientLedgers";
import ClientDemands from "views/atom-pro/Gstr/modules/clientDemands";
import ClientChallan from "views/atom-pro/clientChallan";
import ClientTempNotice from "views/atom-pro/clientTempNotice";
import EChallanFullView from "views/atom-pro/eChallanFullView";
import ClientMycas from "views/atom-pro/clientMycas";
import RequestTasks from "views/client-requests/tasks";
import RequestDocuments from "views/client-requests/documents";
import RequestEvents from "views/client-requests/events";

const Login = loadable(() => import("pages/login"));
const Layout = loadable(() => import("layout/primarylayout"));
const FillForm = loadable(() => import("pages/fill-form"));
const ClientProfile = loadable(() => import("pages/client-profile"));
const ClientRequests = loadable(() => import("pages/client-requests"));
const Profile = loadable(() => import("views/ClientProfile/profile"));
const Credentials = loadable(() => import("views/ClientProfile/credentials"));
const UpComingTasks = loadable(() => import("views/ClientProfile/upcomingTasks/upcoming-tasks"));
const ClientQuantumDocumets = loadable(() => import("views/ClientProfile/quantum/quantum-check"));
const Kyb = loadable(() => import("views/ClientProfile/kyb"));
const KybDetails = loadable(() => import("pages/view-kyb"));
const KybEntry = loadable(() => import("views/ClientProfile/kyb/KybEntry"));
const KybAuditLog = loadable(() => import("pages/view-kyb-audit-log"));
const MyProfile = loadable(() => import("pages/my-profile"));
const ResetPassword = loadable(() => import("pages/reset-password"));
const TaskDetails = loadable(() => import("pages/task-view"));
const RecurringProfile = loadable(() => import("views/ClientProfile/recurringProfile"));
const ViewDscRegister = loadable(() => import("views/ClientProfile/dscRegister/view-dsc-register"));
const DscRegister = loadable(() => import("views/ClientProfile/dscRegister"));
const ClientTasks = loadable(() => import("views/ClientProfile/clientTasks"));
const Archives = loadable(() => import("views/ClientProfile/Archives"));
const Attachments = loadable(() => import("pages/attachments"));
const Dashboard = loadable(() => import("pages/dashboard"));
const GstrClients = loadable(() => import("pages/atom-pro/Gst/clients"))
const GstrView = loadable(() => import("views/atom-pro/Gstr/modules/gstrView"))
const GstrProfile = loadable(() => import("views/atom-pro/Gstr/modules/profile"))
const AdditionalNotice = loadable(() => import("views/atom-pro/Gstr/modules/gstrAdditionalNotice"))
const NoticeAndOrders = loadable(() => import("views/atom-pro/Gstr/modules/noticeAndOrders"))
const NoticeAndOrderFullView = loadable(() => import("views/atom-pro/Gstr/Fullview/noticeAndOrderFullView"))
const AdditonalNoticeFullView = loadable(() => import("views/atom-pro/Gstr/Fullview/additonalNoticeFullView"))
const AtomPro = loadable(() => import("pages/atom-pro"));
const GstPro = loadable(() => import("pages/atom-pro/Gst"));
const GStProDashboard = loadable(() => import("pages/atom-pro/Gst/dashboard"));
const GstReturns = loadable(() => import("pages/compliance"));
const Websites = loadable(() => import("pages/atom-pro/website"));
const IncomeTaxDashboard = loadable(() => import("pages/atom-pro/income-tax-dashboard"));
const OutstandingDemand = loadable(() => import("pages/atom-pro/outstanding-demand"));
const ClientsIncomeTax = loadable(() => import("pages/atom-pro/clients"));
const FyaNotice = loadable(() => import("views/atom-pro/eProceedingNotice/fyaNotice"))
const EproceedingNotice = loadable(() => import("views/atom-pro/eProceedingNotice/eproceedingNotice"));
const Invalidate = loadable(() => import("views/atom-pro/invalidate"));
const GstRegular = loadable(() => import("views/register/GstReturns/Regular"));
const GstCollector = loadable(() => import("views/register/GstReturns/Collector"));
const GstDeductor = loadable(() => import("views/register/GstReturns/Deductor"));
const AtomProCalendar = loadable(() => import("views/atom-pro/Dashboard/Calendar"));
const ProformaPreview = loadable(() => import("pages/billing/proforma/proforma-preview"));
const Expenditure = loadable(() => import("pages/billing/Expenditure"));
const Gst = loadable(() => import("pages/billing/Gst"));
const Tds = loadable(() => import("pages/billing/Tds"));

function RoutesContainer() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="dashboard" />} />
          <Route path="dashboard">
            <Route index element={
              <PageWithPermission name={Permissions.DASHBOARD_VIEW}>
                <Dashboard />
              </PageWithPermission>
            } />
          </Route>
          <Route path="client-requests" element={<ClientRequests />}>
            <Route index element={
                <RequestTasks />
            } />
            <Route path="documents" element={
                <RequestDocuments />
            } />
            <Route path="events" element={<RequestEvents />} />
          </Route>
          <Route path="client-profile" element={<ClientProfile />}>
            <Route index element={
              <PageWithPermission name={Permissions.CLIENT_PROFILE_VIEW}>
                <Profile />
              </PageWithPermission>
            } />
            <Route path="credentials" element={
              <PageWithPermission name={Permissions.CLIENT_PASSWORDS_VIEW}>
                <Credentials />
              </PageWithPermission>
            } />
            <Route path="upcoming-tasks" element={<UpComingTasks />} />
            <Route path="client-quantum-documents" element={<ClientQuantumDocumets />} />
            <Route path="kyb" element={
              <PageWithPermission name={Permissions.CLIENT_KYB_VIEW}>
                <Kyb />
              </PageWithPermission>
            } />
            <Route path="dsc-register">
              <Route index element={
                <PageWithPermission name={Permissions.CLIENT_REGISTER_VIEW}>
                  <DscRegister />
                </PageWithPermission>
              } />
              <Route path=":dscId" element={
                <PageWithPermission name={Permissions.CLIENT_REGISTER_VIEW}>
                  <ViewDscRegister />
                </PageWithPermission>
              } />
            </Route>
            <Route path="recurring-profile" element={
              <PageWithPermission name={Permissions.CLIENT_RECURRING_PROFILE_VIEW}>
                <RecurringProfile />
              </PageWithPermission>
            } />
            <Route path="client-tasks" element={
              <PageWithPermission name={Permissions.VIEW_ALL_TASKS}>
                <ClientTasks />
              </PageWithPermission>
            } />
            <Route path="compliance" element={
              <PageWithPermission name={Permissions.VIEW_ALL_TASKS}>
                <GstReturns />
              </PageWithPermission>
            } />
            <Route path="archives" element={
              <PageWithPermission name={Permissions.VIEW_ALL_TASKS}>
                <Archives />
              </PageWithPermission>
            } />
          </Route>
          <Route path="tasks">
            <Route
              index
              element={
                <PageWithPermission name={Permissions.VIEW_ALL_TASKS}>
                  <Tasks />
                </PageWithPermission>
              }
            />
            <Route path=":taskId" element={<TaskDetails />} />
          </Route>
          <Route path="billing" element={<Billing />}>
            <Route path="clients" element={
              <PageWithPermission name={Permissions.BILLING_CLIENT_OVERVIEW}>
                <Billingclientview />
              </PageWithPermission>
            } />
            <Route path="invoices" element={
              <PageWithPermission name={Permissions.BILLING_CLIENT_INVOICE}>
                <Invoices />
              </PageWithPermission>
            } />
            <Route path="receipts" element={
              <PageWithPermission name={Permissions.BILLING_CLIENT_RECEIPT}>
                <Receipts />
              </PageWithPermission>
            } />
            <Route path="proforma" element={<Proforma />} />
            <Route path="expenditure" element={<Expenditure />} />
            <Route path="gst" element={<Gst />} />
            <Route path="tds" element={<Tds />} />
          </Route>
          <Route path="atom-pro">
            <Route index element={<Websites />} />
            <Route path="income-tax">
              <Route index element={<IncomeTaxDashboard />} />
              <Route path="demands" element={<OutstandingDemand />} />
              {/* <Route path="clients" element={<ClientsIncomeTax />} /> */}
              <Route path="returns" element={<IncomeTaxReturns />} />
              <Route path="dashboard" element={<IncomeTaxDashboard />} />
              <Route path="clients" element={<ClientsIncomeTax />} />
              <Route path="calendar" element={<AtomProCalendar />} />
              <Route path="return/:id" element={<ReturnFullView />} />
              <Route path="demand/:id" element={<OutstandingDemandView />} />
              <Route path="proceeding-action/:id" element={<EproceedingView />} />
              <Route path="proceeding-information/:id" element={<EproceedingFyiView />} />
              <Route path="proceeding-action/notice-fya/:itemId" element={<FYANoticeView />} />
              <Route path="proceeding-information/notice-fyi/:itemId" element={<FYINoticeView />} />
              <Route path="forms" element={<IncomeTaxForms />} />
              <Route path="proceedings" element={<IncomeTaxEProceedings />} />
              <Route path="order" element={<IncomeTaxOrder />} />
              <Route path="forms/:id" element={<FormFullView />} />
              <Route path="client/:id" element={<ClientFullView />} />
              <Route path="reports" element={<IncomeTaxReports />} />
              <Route path="new-updates" element={<NewUpdates />} />
              <Route path="new-updates/:id" element={<UpdatesFullVIew />} />
              <Route path="fya-notice" element={<FyaNotice />} />
              <Route path="eproceeding-notice" element={<EproceedingNotice />} />
              <Route path="invalidate" element={<Invalidate />} />
              <Route path="incometax/:incometaxid" element={<ClientIncomeTaxView />} >
                <Route index element={<ClientFullView />} />
                <Route path="form" element={<ClientForm />} />
                <Route path="demand" element={<ClientDemand />} />
                <Route path="proceeding" element={<ClientProceeding />} />
                <Route path="form/:id" element={<FormFullView />} />
                <Route path="return" element={<ClientIncometaxReturns />} />
                <Route path="challan" element={<ClientChallan />} />
                <Route path="temp-notice" element={<ClientTempNotice />} />
                <Route path="return/:id" element={<ReturnFullView />} />
                <Route path="e-challan/:id" element={<EChallanFullView />} />
                <Route path="my-cas" element={<ClientMycas />} />
                <Route path="demand" element={<OutstandingDemand />} />
                <Route path="activity" element={<ClientIncomeTaxActivityLog />} />
                <Route path="client-status" element={<ClientAutoStatus />} />
              </Route>
            </Route>
            <Route path="gst">
              <Route path="dashboard" element={<IncomeTaxDashboard />} />
              <Route path="regular" element={<GstRegular />} />
              <Route path="collector" element={<GstCollector />} />
              <Route path="deductor" element={<GstDeductor />} />
              <Route path="clients" element={<GstrClients />} />
              <Route path="gstr/:gstrid" element={<GstrView />} >
                <Route index element={<GstrProfile />} />
                <Route path="compliance" element={<GstrCompliance />} />
                <Route path="additional-notice" element={<AdditionalNotice />} />
                <Route path="notice-orders" element={<NoticeAndOrders />} />
                <Route path="ledger" element={<ClientLedgers />} />
                <Route path="demand" element={<ClientDemands />} />
                <Route path="notice-orders/:id" element={<NoticeAndOrderFullView />} />
                <Route path="additional-notice/:id" element={<AdditonalNoticeFullView />} />
              </Route>
            </Route>
            <Route path="income-tax-tan">
              <Route path="dashboard" element={<TanDashboard />} />
              <Route path="calendar" element={<AtomProTanCalendar />} />
              <Route path="e-challans" element={<TanIncomeTaxChallans />} />
              <Route path="e-challan/:id" element={<TanEChallanFullView />} />
              <Route path="forms" element={<TanIncomeTaxForms />} />
              <Route path="proceedings-excel" element={<TanExcelNotices />} />
              <Route path="traces-communication" element={<TraceCommunication />} />
              <Route path="demand" element={<TanIncomeTaxDemands />} />
              <Route path="form/:id" element={<TanFormFullView />} />
              <Route path="demand/:id" element={<TraceDemandFullView />} />
              <Route path="my-cas" element={<TanIncomeTaxMycas />} />
              <Route path="reports" element={<TanIncomeTaxReports />} />
              <Route path="new-updates" element={<TanNewUpdates />} />
              <Route path="new-updates/:id" element={<TanUpdatesFullVIew />} />
              <Route path="invalidate" element={<TanTraceInvalidate />} />
              <Route path="tds-forms" element={<TanTdsFormAnalytics />} />
              <Route path="e-proceeding-excel" element={<TempTanNoticesFilterPage />} />
              <Route path="incometax/:incometaxid" element={<TanClientIncomeTaxView />}>
                <Route index element={<TanClientFullView />} />
                <Route path="challan" element={<TanClientChallan />} />
                <Route path="e-challan/:id" element={<TanEChallanFullView />} />
                <Route path="form" element={<TanClientForm />} />
                <Route path="proceedings-excel" element={<TanClientTempNotice />} />
                <Route path="traces-communication" element={<TanTraceCommunication />} />
                <Route path="demand" element={<TraceClientDemand />} />
                <Route path="form/:id" element={<TanFormFullView />} />
                <Route path="demand/:id" element={<TraceDemandFullView />} />
                <Route path="my-cas" element={<TanClientMycas />} />
                <Route path="activity" element={<TanClientIncomeTaxActivityLog />} />
                <Route path="client-status" element={<TanClientAutoStatus />} />
              </Route>
            </Route>
          </Route>
          <Route path="storage">
            <Route
              index
              element={
                <PageWithPermission name={Permissions.STORAGE_VIEW}>
                  <Attachments />
                </PageWithPermission>
              }
            />
          </Route>
          <Route path="my-profile" element={<MyProfile />} />
        </Route>
        <Route path="/billing/invoices/:invoiceId/preview" element={<InvoicePreview />} />
        <Route path="/billing/proforma/:proformaId/preview" element={<ProformaPreview />} />
        <Route path="/billing/receipts/:receiptId/preview" element={<ReceiptPreview />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/fill-form/:formId" element={<FillForm />} />
        <Route path="/view-kyb/:formId" element={<KybDetails />}>
          <Route index element={<Navigate to="view-details" />} />
          <Route path="view-details" element={<KybEntry />} />
          <Route path="audit-log" element={<KybAuditLog />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default RoutesContainer;
